import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const receiverConfigurationFields: FieldInterface[] = []

const receiverConfigurationRelations: RelationInterface[] = [
  {
    key: '_presomptive',
    originKey: 'presomptive',
    objectType: OBJECT_TYPES.person,
    isMultiple: true,
  },
  {
    key: '_no_part',
    originKey: 'no_part',
    objectType: OBJECT_TYPES.person,
    isMultiple: true,
  },
  {
    key: '_shared',
    originKey: 'shared',
    objectType: OBJECT_TYPES.person,
    isMultiple: true,
  },
]

export { receiverConfigurationFields, receiverConfigurationRelations }
